import React, { useEffect, useState } from 'react';
import { popupApi, getImageUrl } from '../api'; 
import ImageLoader from './common/ImageLoader';
import './AdminPopup.css'; 

const AdminPopup = () => {
  const [popup, setPopup] = useState(null);
  const [file, setFile] = useState(null);
  const [previewUrl, setPreviewUrl] = useState(null);
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    fetchPopup();
  }, []);

  const fetchPopup = async () => {
    try {
      const res = await popupApi.get();
      setPopup(res.data);
    } catch (err) {
      console.error('Fetch error:', err);
    }
  };
  
  const handleImageChange = (e) => {
    const selected = e.target.files[0];
    if (selected) {
      setFile(selected);
      setPreviewUrl(URL.createObjectURL(selected));
    }
  };

  const handleUpload = async (e) => {
    e.preventDefault();
    if (!file) return alert('Please select an image.');
    setLoading(true);
    const formData = new FormData();
    formData.append('image', file);
    try {
      await popupApi.upload(formData);
      alert('✅ Popup image updated successfully!');
      setFile(null);
      setPreviewUrl(null);
      e.target.reset();
      fetchPopup();
    } catch (err) {
      console.error('Upload error:', err);
      alert('❌ Failed to upload popup.');
    } finally {
      setLoading(false);
    }
  };

  const handleDelete = async () => {
    if (!window.confirm('Delete popup image? This will disable the announcement modal for visitors.')) return;
    try {
      await popupApi.delete();
      alert('🗑️ Popup deleted!');
      setPopup(null);
      fetchPopup();
    } catch (err) {
      console.error('Delete error:', err);
    }
  };

  return (
    <div className="admin-popup-wrapper">
      <div className="admin-panel-header">
        <div className="panel-title-group">
          <i className="fas fa-window-restore title-icon"></i>
          <div>
            <h2>Site Launch Popup Modal</h2>
            <p className="panel-subtitle">Manage modal banner that displays automatically upon website load</p>
          </div>
        </div>
      </div>

      <div className="popup-management-grid">
        {/* Current Active Preview */}
        <div className="current-popup-card">
          <div className="popup-status-header">
            <span className="card-badge-label">Active Popup Modal</span>
            <span className={`status-pill ${popup?.imagePath ? "active" : "inactive"}`}>
              <i className={`fas ${popup?.imagePath ? "fa-check-circle" : "fa-times-circle"}`}></i>
              {popup?.imagePath ? "Live on Site" : "Disabled"}
            </span>
          </div>

          {popup?.imagePath ? (
            <div className="popup-preview-frame">
              <ImageLoader 
                src={getImageUrl(popup.imagePath)} 
                alt="Active Popup" 
                className="popup-preview-image" 
              />
              <button className="delete-popup-btn" onClick={handleDelete}>
                <i className="fas fa-trash-alt"></i> Disable &amp; Delete Popup
              </button>
            </div>
          ) : (
            <div className="no-popup-placeholder">
              <i className="fas fa-image placeholder-ic"></i>
              <p>No active popup currently configured. Upload a graphic to display on load.</p>
            </div>
          )}
        </div>

        {/* Upload Card */}
        <div className="upload-popup-card">
          <h3 className="sub-heading-tag">
            <i className="fas fa-cloud-upload-alt"></i> {popup?.imagePath ? "Replace Popup Graphic" : "Upload New Popup"}
          </h3>

          <form onSubmit={handleUpload} className="admin-glass-form">
            <div className="admin-form-group">
              <label>Select Popup Graphic (JPG, PNG, WEBP)</label>
              <input 
                type="file" 
                accept="image/*" 
                onChange={handleImageChange} 
                required 
              />
            </div>

            {previewUrl && (
              <div className="popup-upload-preview">
                <img src={previewUrl} alt="New Preview" />
              </div>
            )}

            <button type="submit" className="admin-btn-primary" disabled={loading}>
              {loading ? (
                <>
                  <i className="fas fa-circle-notch fa-spin"></i> Uploading...
                </>
              ) : (
                <>
                  <i className="fas fa-upload"></i> {popup?.imagePath ? "Replace & Update" : "Publish Popup"}
                </>
              )}
            </button>
          </form>
        </div>
      </div>
    </div>
  );
};

export default AdminPopup;